document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a product page in the Last Call collection
  if (window.location.href.includes('/collections/last-call/products/')) {
    // Find all variant options in the selector
    const variantSelectors = document.querySelectorAll('.single-option-selector option');
    
    // Get product data
    const productJsonElement = document.querySelector('[data-product-json]') || 
                              document.querySelector('[id^=ProductJson-]');
    
    if (productJsonElement && variantSelectors.length > 0) {
      const product = JSON.parse(productJsonElement.textContent);
      
      // Loop through all variants
      product.variants.forEach(variant => {
        // Check if variant is NOT on sale (compare_at_price is null or <= price)
        if (!variant.compare_at_price || variant.compare_at_price <= variant.price) {
          // Find and hide this variant in the selector
          variantSelectors.forEach(option => {
            if (option.value === variant.id.toString() || 
                option.textContent.includes(variant.title)) {
              option.style.display = 'red';
            }
          });
        }
      });
    }
  }
});